var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalanderWithCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 292,
    viewBox: "0 0 324 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.37 108.03H274.37",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.87 78.03V33.03",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.37 78.03V33.03",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.37 78.03V33.03",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.87 78.03V33.03",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M236.87 78.03V33.03",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M274.37 243V55.53H49.37V243C49.37 246.978 50.9503 250.794 53.7634 253.607C56.5764 256.42 60.3918 258 64.37 258H259.37C263.348 258 267.164 256.42 269.977 253.607C272.79 250.794 274.37 246.978 274.37 243Z",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.37 160.53L154.37 205.53L124.37 175.53",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalanderWithCheck);
export default __webpack_public_path__ + "static/media/calanderWithCheck.f96a7cffdd978ccc13395dc1dcd8d463.svg";
export { ForwardRef as ReactComponent };